import { array, boolean, nativeEnum, object } from 'zod';

import { Payment_Instrument_Type } from '@occc/graphql';

export const PaymentMethodConstraintSchema = object({
  isEnabled: boolean(),
  paymentInstruments: array(nativeEnum(Payment_Instrument_Type)).optional(),
});
